import { ChatCompletionRequestMessage } from 'openai';
import { ReactFlowInstance, XYPosition } from 'reactflow';
import { createTravellerEdge } from '../../edges/traveller-edge/traveller-edge.helper';
import { InstanceMap, InstanceState } from '../../triggers/semantic-dive/semantic-dive';
import { uuid } from '../../utils';
import { TopicNodeData, TypeTopicNode } from './topic-node.model';

// Unlike other create Nodes
export const createTopicNode = (
  topic: string,
  parentId: string,
  position: XYPosition,
  chatHistory: ChatCompletionRequestMessage[],
  isRecommended: boolean,
  reactFlowInstance: ReactFlowInstance,
  showToolBar: boolean = true,
) => {
  const newTopicNode: TypeTopicNode = createTopicNodeToReturn(
    topic,
    parentId,
    position,
    chatHistory,
    isRecommended,
    showToolBar,
  );

  // TODO: Make travellerEdge show or no show depending on state
  const newTravellerEdge = createTravellerEdge(parentId, newTopicNode.id, false)
  reactFlowInstance.addNodes(newTopicNode);
  reactFlowInstance.addEdges(newTravellerEdge);
  return newTopicNode;
}

export const createTopicNodeToReturn = (
  topic: string,
  parentId: string,
  position: XYPosition,
  chatHistory: ChatCompletionRequestMessage[],
  isRecommended: boolean,
  showToolBar?: boolean,
) => {
  const topicId = `topic-${uuid()}`;
  const newTopicNode: TypeTopicNode = {
    id: topicId,
    type: 'topic',
    dragHandle: '.drag-handle',
    position,
    data: {
      parentId,
      originalId: topicId,
      chatHistory,
      instanceState: InstanceState.NONE,
      state: {
        topic,
        isRecommended,
        toolbarAvailable: showToolBar,
      }
    } as TopicNodeData,
    selectable: true,
    zIndex: -100,
  };
  return newTopicNode;
}

export const getAllReferenceCopies = (
  topicNode: TypeTopicNode,
  instanceMap: InstanceMap,
): TypeTopicNode[] => {
  return Object.values(instanceMap)
  .map(instance => instance.jsonObject.nodes
    .filter(node => node.type ==='topic' &&
      node.data.originalId === topicNode.data.originalId)
    .concat(
      instance.topicNode.data.originalId === topicNode.data.originalId ?
      instance.topicNode : [])
  )
  .flat()
}